import styled from 'styled-components';
import media from 'styled-media-query';

export const Container = styled.div`
  display: grid;
  place-items: center;
  height: 100vh;
  margin-top: 3rem;
`;

export const BlueBox = styled.div`
  height: 80vh;
  width: 100vw;
  background: ${({ theme }) => theme.colors.blue};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Wrapper = styled.div`
  padding: 2.4rem;
  text-align: center;
  width: 90%;

  ${media.greaterThan('medium')`
    width: 38%
  `}
`;

export const MainBox = styled.div`
  border-bottom: 2px solid #fff;
  padding: 1rem 3rem;
  margin: 2rem;
`;

export const Text = styled.span`
  color: #fff;
  font-size: 3rem;

  ${media.greaterThan('medium')`
    font-size: 3.6rem;
  `}
`;

export const Logo = styled(Text)`
  font-family: 'Montserrat';
  font-style: italic;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 3.6rem;
`;

export const Bold = styled(Text)`
  font-weight: 700;
`;
